import { render, staticRenderFns } from "./WidgetProjectAuthors.vue?vue&type=template&id=5504cdcc&scoped=true"
import script from "./WidgetProjectAuthors.vue?vue&type=script&lang=js"
export * from "./WidgetProjectAuthors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5504cdcc",
  null
  
)

export default component.exports